/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:00:49
 * @LastEditors: shenlin
 * @LastEditTime: 2022-08-16 15:39:51
 */
// 配置
let FORM_IP // 流程
if (process.env.NODE_ENV === 'development') {
  // 本地
  FORM_IP = `http://${window.location.hostname}:8561`
} else if (window.location.href.includes('8827')) {
  // 测试
  FORM_IP = 'http://10.1.1.195:8420' // 表单
} else if (window.location.href.includes('yscredit')) {
  // 线上
  // FORM_IP = 'https://lsqym-form.yscredit.com' // 表单
  FORM_IP = 'https://lsqym-form.yscredit.com' // 表单
  // http://58.51.61.130:8530
} else if (window.location.href.includes('39.191.223.154')) {
  // 信创云
  FORM_IP = 'http://39.191.223.154:8302'
} else {
  FORM_IP = 'https://qym.jxj.lishui.gov.cn:8302' // 表单
}

module.exports = {
  FORM_IP
}
